module.exports = __webpack_public_path__ + "assets/img/car_1.083f9233.png";